<template>
  <div>
    <v-data-table
      v-model="selected"
      :items="tableData"
      :headers="fiteredTableHeaders"
      :loading="loading || internalLoading > 0"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus'
      }"
      show-select
      class="elevation-1 admin-table"
      loading-text="Loading... Please wait"
    >
      <template v-slot:item.status="{item}">
        <DeviceStatusMarker :status="item.status" />
      </template>
      <template v-slot:item.actions="{item}">
        <div class="reports-action-launch" @click="launchRowAction">
          <v-icon>mdi-dots-vertical</v-icon>
          <ActionContainer :ref="item.key" :heading="'Action'" class="report-action-options">
            <ActionItem 
              :disabled="!$can('assignDeviceToVehicle')"
              label="Assign"
              icon="mdi-link"
              @click.native="showAssignmentAddCurrent(item)"
            />
            
            <ActionItem
              :disabled="!$can('viewDeviceInfo')"
              label="Device Config"
              icon="mdi-settings"
              @click.native="toggleDeviceConfig(item)"
            />

            <ActionItem 
              :disabled="!$can('deleteDevice')"
              label="Delete"
              icon="mdi-delete"
              @click.native="deleteDevice(item)"/>
            <ActionItem 
              label="Format Disk"
              icon="mdi-harddisk"
              @click.native="toggleFormat(item)"
            />
            <ActionItem 
              label="Reboot Device"
              icon="mdi-power"
              @click.native="toggleReboot(item)"/>
          </ActionContainer>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import ActionContainer from '@/components/general/ActionContainer.vue';
import ActionItem from '@/components/general/ActionItem.vue';
import { GetUnassignedDevicePresence } from "@/services/API.js";
import DeviceStatusMarker from "@/components/general/DeviceStatusMarker.vue";

logger
import { Logger } from "aws-amplify"
const logger = new Logger("Device Management")

export default {
  name: 'UnassignedDevicesTable',
  components: {
    ActionContainer,
    ActionItem,
    DeviceStatusMarker
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'OTC',
          value: 'otc',
          align: 'left'
        },
        {
          text: 'Install Tag',
          value: 'install_tag',
          align: 'left'
        },
        {
          text: 'Status',
          value: 'status',
          align: 'left'
        },
        {
          text: 'IMEI',
          value: 'imei',
          align: 'left'
        },
        {
          text: 'Model',
          value: 'model',
          align: 'left'
        },
        {
          text: 'Firmware Version',
          value: 'firmware',
          align: 'left'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'left'
        }
      ],
      selected: [],
      presence: {},
      internalLoading: 0,
      tableData: []
    }
  },

  computed: {
    fiteredTableHeaders () {
				return this.headers.filter(i => !this.hideHeader[i.value])
			},
			hideHeader () {
				return {
					status: !this.$can('getVehiclePresence')
				}
			},
  },

  watch: {
    selected(val) {
      this.$emit('selectionUpdated', val);
    },
    data () {
      this.setTableData()
    }
  },
  mounted () {
    this.updatePres() 
    this.setTableData()
  },
  methods: {
    setTableData () {
      this.internalLoading++
      this.tableData = this.data.map(i => {
        i.status = this.presence[i.id] || 'unknown'
        return i
      })
      this.internalLoading--
    },
    showAssignmentAddCurrent(item) {
      this.toggleAssignmentComp();

      let selectedAmount = this.selected.length;

      if (item) {
        if(!this.selected.includes(item)) {
          this.selected.push(item);
        }
      } else {
        // Clear selection for single select

        if (selectedAmount === 1) {
          this.selected = [];
        }
      }
    },
    updatePres () {
      this.internalLoading++
      GetUnassignedDevicePresence().then(res => {
        logger.debug("unassigned device pres updated", res)
        this.presence = res.Presences 
          ? res.Presences.reduce((map, item) => {
            map[item.device_id] = item.status
            return map
          }, {})
          : {}

        this.setTableData()
        this.internalLoading--
      }).catch(err => {
        this.internalLoading--
        logger.debug("device failed to update", err)
      })
    },
    launchRowAction(e) {
      let allOptions = document.querySelectorAll(".report-action-options");

      for (let option of allOptions) {
        option.classList.remove('active-options');
        if (option === e.target.nextSibling) {
          option.classList.toggle('active-options');
        } 
      }
    },
    toggleFormat(item) {
      this.$emit('toggleFormat', item);
    },
    toggleAssignmentComp() {
      this.$emit('toggleAssignmentComp');
    },
    showInfoModal(item) {
      this.$emit('showUnassignedInfoModal', item);
    },
    toggleReboot(item) {
      this.$emit('toggleReboot', item);
    },
    updateOTC(item) {
      this.$emit('updateOTC', item);
    },
    deleteDevice(item) {
      this.$emit('deleteDevice', item, 'unassigned');
    },
    toggleDeviceConfig(item) {
      this.$emit('toggleDeviceConfig', item)
    }
  }
}
</script>

<style lang="scss">

</style>